import React from 'react';
import { EmailPreviewModal } from '../features/contacts/activity/EmailPreviewModal';
import { useEmailPreviewStore } from '../../stores/useEmailPreviewStore';

/**
 * Singleton mount for the email preview modal. Sits at the app root and
 * reads `useEmailPreviewStore` — so any call to `previewEmail(...)` (or
 * the store's `open(...)`) from anywhere in the tree shows the new
 * in-app email viewer instead of a blank new browser tab.
 */
export const GlobalEmailPreviewModal: React.FC = () => {
  const email = useEmailPreviewStore((s) => s.email);
  const close = useEmailPreviewStore((s) => s.close);

  return (
    <EmailPreviewModal
      isOpen={!!email}
      onClose={close}
      email={email}
      contactName={email?.contactName}
      contactEmail={email?.contactEmail}
      contactId={email?.contactId ?? undefined}
      onContactClick={email?.onContactClick}
    />
  );
};
